<template>
  <div id="core" class="core">
    <div class="title">
      {{ $theme ? '核心技术' : 'CORE TECHNOLOGY' }}
      <div :class="`desc${$theme?'':' eng'}`">{{
          $theme ? '完备的自主核心技术体系支撑工业物联网全链条重要环节' : 'A complete independent core technology system supports important links in the entire chain of industrial Internet of Things'
        }}
      </div>
    </div>
    <div id="container" class="container" @wheel.prevent="handleMouseWheel">
      <div class="card-box" :style="{transform: 'rotateY('+rotateY+'deg) rotateZ('+rotateZ+'deg)'}"
           @wheel.stop="handleMouseWheel2">
        <div class="card" :style="cardStyle(item)" v-for="item in cards" :key="item.id" @click="changeCard(item)">
          <img :src="require(`@/assets/img/brand-honor/core/${$theme?'':'eng/'}${item.id}.png`)"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Core',
  components: {},
  data() {
    return {
      interval: null,
      active: 1,
      rotateY: 46,
      rotateZ: -3,
      cards: [
        {
          id: 1,
          name: '多模异构无线承载物联网'
        },
        {
          id: 2,
          name: '物联网SoC芯片技术'
        },
        {
          id: 3,
          name: '湖仓一体数据处理技术'
        },
        {
          id: 4,
          name: '市域级3D模型可视化技术'
        },
        {
          id: 5,
          name: '图像识别及人工智能技术'
        },
        {
          id: 6,
          name: '高清对讲及视频指挥通信技术'
        },
        {
          id: 7,
          name: '流媒体音视频技术'
        },
        {
          id: 8,
          name: '物联网安全防护技术'
        }
      ],
      numCards: 8
    }
  },
  computed: {},
  created() {
    this.createCards();
  },
  mounted() {
    document.getElementById("container").addEventListener('wheel', this.handleMouseWheel);
    this.interval = setInterval(() => {
      const { active } = this
      this.changeCard(this.cards.find(({id})=>id === (active === 1 ? 8 : active - 1)))
    },3000)
  },
  methods: {
    createCards() {
      for (let i = 1; i < this.numCards + 1; i++) {
        this.cards[i - 1] = {
          ...this.cards[i - 1],
          angle: (i / this.numCards) * 360,
          id: i,
        }
      }
    },
    changeCard(item) {
      this.active = item.id
      const {rotateY} = this
      let {angle} = item
      // console.log('angle', angle)
      while ((angle - rotateY) > 180) {
        angle -= 360
      }
      while ((rotateY - angle) > 180) {
        angle += 360
      }
      // console.log(angle, rotateY)
      this.rotateY = angle + 1
      // this.rotateZ = item.id - 4
    },
    cardStyle(card) {
      return {
        zIndex: this.numCards - card.id,
        filter: card.id === this.active ? "grayscale(0) brightness(1)" : "grayscale(0) brightness(1)",
        // filter: card.id === this.active ? "grayscale(0) brightness(1)" : "grayscale(1) brightness(0.5)",
        transform: `rotateY(${-360 / this.numCards * card.id}deg) translateZ(800px) scale(${card.id === this.active ? 1 : 0.85})`
      };
    },
    handleMouseWheel(e) {
      const {deltaY} = e
      if (deltaY > 0) {
        this.changeCard(this.cards[this.active === 1 ? 7 : this.active - 2])
      } else {
        this.changeCard(this.cards[this.active === 8 ? 0 : this.active])
      }
    },
    handleMouseWheel2(event) {
      const div = document.getElementById('container');
      const rect = div.getBoundingClientRect(); // 获取元素的位置和尺寸
      if (event.clientX > rect.left && event.clientX < rect.right &&
          event.clientY > rect.top && event.clientY < rect.bottom) {
        event.preventDefault()
        this.handleMouseWheel(event)
      }
    }
  },
  beforeDestroy() {
    document.getElementById("container").removeEventListener('wheel', this.handleMouseWheel);
    clearInterval(this.interval)
    this.interval = null
  }
}
</script>
<style lang="scss" scoped>
@import "Index";
</style>
